<template>
        <div class="d-flex flex-column flex-grow-1 default-text-font">
            <div class="android_setting_item_container">
                <label class="scv-check-label-box">
                    <input type="checkbox" v-model="this.untrustedAppsPolicy" @change="onChange" v-bind:disabled="!isCheckMobileAndroid">
                    <span>提供元が不明なアプリケーションのインストールを禁止する</span>
                </label>
                <InformationManual :arMessage="['<div>利用を許可している提供元が不明なアプリケーションも、インストールは禁止されます。<br />※すでにインストールされている場合は、引き続き利用することができます。</div>']"
                                    style="margin-left: 8px;" />
            </div>
        </div>
</template>

<script lang="ts">
    import { Options, Vue } from "vue-class-component";
    import InformationManual from '@/components/InformationManual.vue';
    import { AndroidPolicyWrapper } from '@/models/Mobile/Android/AndroidPolicyWrapper'
    import * as schema from '@/models/Mobile/Android/AndroidManagementV1Schema'

    @Options({
        components: {
            InformationManual,
        },
        props: {
            isCheckMobileAndroid: { type: Boolean, default: false }, // AndroidライセンスがONかどうか
        },
        emits: ['notifyUpdate'],
    })

    export default class AppMgrSettingInstalledForAndroid extends Vue {

        private untrustedAppsPolicy = false; 

        private readonly DISALLOW_INSTALL = "DISALLOW_INSTALL";
        private readonly ALLOW_INSTALL_DEVICE_WIDE = "ALLOW_INSTALL_DEVICE_WIDE";

        /**
         * @brief	設定変更時
         * @return	なし
         */
        public onChange(): void {
            this.$emit("notifyUpdate");
        }


        /**
         * 設定⇒UIデータ
         * @param[in]   settings : ポリシー設定
         */
        public LoadUIData(settings: AndroidPolicyWrapper): void {
            // 提供元不明
            this.untrustedAppsPolicy = false;
            if (null != settings.policy.advancedSecurityOverrides && settings.policy.advancedSecurityOverrides.untrustedAppsPolicy) {
                if (settings.policy.advancedSecurityOverrides.untrustedAppsPolicy == this.DISALLOW_INSTALL) {
                    this.untrustedAppsPolicy = true;
                }
            }
        }

        /**
         * UIデータ⇒設定
         * @param[in/out]  settings : ポリシー設定
         */
        public SaveUIData(settings: AndroidPolicyWrapper): void {
            if (null == settings.policy.advancedSecurityOverrides) {
                settings.policy.advancedSecurityOverrides = new schema.AMAPI_AdvancedSecurityOverrides();
            }
            if (this.untrustedAppsPolicy) {
                settings.policy.advancedSecurityOverrides.untrustedAppsPolicy = this.DISALLOW_INSTALL;
            }
            else {
                settings.policy.advancedSecurityOverrides.untrustedAppsPolicy = this.ALLOW_INSTALL_DEVICE_WIDE;
            }
        }

        // このようなことはやりたくないがやむを得ず
        public getUntrustedAppsPolicy():boolean{
            return this.untrustedAppsPolicy;
        }
    }
</script>

<style scoped>
    /* 設定項目 */
    .android_setting_item_container {
        display: flex;
        align-items: center;
        flex-direction: row;
    }
</style>
